import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ConnectorServiceDescState } from '../../actions/types/connectors/GetConnectorServiceTypes';

/**
 * Initial Dashboard state in store
 */
export const initialState: ConnectorServiceDescState = {
  isLoading: false,
  success: false,
  errorMessage: '',
  connectorServiceDesc: [],
};

/**
 * get metric summary Slice to get metric
 */
export const getConnectorServiceDescSlice = createSlice({
  name: 'getMetricsSummary',
  initialState,
  reducers: {
    getConnectorServiceDescStarted: (state) => {
      state.isLoading = true;
    },
    getConnectorServiceDescSuccess: (state, action: PayloadAction<any>) => {
      state.isLoading = false;
      state.success = true;
      state.errorMessage = '';
      state.connectorServiceDesc = action.payload;
    },

    getConnectorServiceDescFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = action.payload;
      state.connectorServiceDesc = initialState.connectorServiceDesc;
    },

    clearConnectorServiceDesc: (state) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = '';
      state.connectorServiceDesc = initialState.connectorServiceDesc;
    },
  },
});

export const {
  getConnectorServiceDescStarted,
  getConnectorServiceDescSuccess,
  getConnectorServiceDescFail,
  clearConnectorServiceDesc,
} = getConnectorServiceDescSlice.actions;
export default getConnectorServiceDescSlice.reducer;
